import { Link } from "react-router-dom";

export default function Logo({ variant = "ink", className = "" }) {
  const color = variant === "white" ? "#ffffff" : "#01696f";
  return (
    <Link to="/" data-testid="logo-link" className={`flex items-center gap-2 ${className}`}>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
        <rect x="1" y="1" width="26" height="26" stroke={color} strokeWidth="1.5" />
        <path d="M7 19V9h3v10H7Zm5 0V9h2.5l3 6.2V9H20v10h-2.5l-3-6.2V19H12Z" fill={color} />
      </svg>
      <span
        className="font-display font-bold text-lg tracking-tight"
        style={{ color, letterSpacing: "-0.02em" }}
      >
        Overheidskrachten
      </span>
    </Link>
  );
}
